import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_tradein_stock_hdr_RowInterface {
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  serial_no: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  ccy: fromDatatype.VarcharDatatypeInterface;
  guid: fromDatatype.GuidDataFieldInterface;
  category_guid: fromDatatype.GuidDataFieldInterface;
  guid_company: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  sub_ledger_guid: fromDatatype.GuidDataFieldInterface;
  guid_fi_item_hdr: fromDatatype.GuidDataFieldInterface;
  purchase_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  warranty_expiry: fromDatatype.TimestampTzDatatypeInterface;
  purchase_price: fromDatatype.NumericDatatypeInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  purchase_amount: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_tradein_stock_hdr_RowClass implements bl_fi_tradein_stock_hdr_RowInterface {
  code: fromDatatype.VarcharDatatypeInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  serial_no: fromDatatype.VarcharDatatypeInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  ccy: fromDatatype.VarcharDatatypeInterface;
  guid: fromDatatype.GuidDataFieldInterface;
  category_guid: fromDatatype.GuidDataFieldInterface;
  guid_company: fromDatatype.GuidDataFieldInterface;
  guid_location: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  glcode_guid: fromDatatype.GuidDataFieldInterface;
  sub_ledger_guid: fromDatatype.GuidDataFieldInterface;
  guid_fi_item_hdr: fromDatatype.GuidDataFieldInterface;
  purchase_date: fromDatatype.TimestampTzDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  warranty_expiry: fromDatatype.TimestampTzDatatypeInterface;
  purchase_price: fromDatatype.NumericDatatypeInterface;
  qty: fromDatatype.NumericDatatypeInterface;
  purchase_amount: fromDatatype.NumericDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
}
